import React, { useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';

interface Period {
  subject: string;
  teacher: string;
  time: string;
}

interface DaySchedule {
  [key: string]: Period[];
}

interface TimeTableProps {
  domain: string;
}

const TimeTable: React.FC<TimeTableProps> = ({ domain }) => {
  const [classId, setClassId] = useState('');
  const [section, setSection] = useState('');
  const [timetable, setTimetable] = useState<DaySchedule | null>(null);
  const [loading, setLoading] = useState(false);

  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  const loadTimetable = async () => {
    if (!classId || !section) return;

    setLoading(true);
    try {
      const timetableRef = doc(db, `school-users/${domain}/timetables`, `${classId}-${section}`);
      const timetableDoc = await getDoc(timetableRef);
      
      if (timetableDoc.exists()) {
        setTimetable(timetableDoc.data() as DaySchedule);
      } else {
        alert('Timetable not found');
      }
    } catch (error) {
      console.error('Error loading timetable:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header bg-white py-3">
        <h5 className="mb-0">Class Time Table</h5>
      </div>
      <div className="card-body">
        <div className="row mb-4 g-3">
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder="Enter Class"
              value={classId}
              onChange={(e) => setClassId(e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder="Enter Section"
              value={section}
              onChange={(e) => setSection(e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <button className="btn btn-primary w-100" onClick={loadTimetable} disabled={loading}>
              {loading ? 'Loading...' : 'Load Timetable'}
            </button>
          </div>
        </div>

        {timetable && (
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th>Day</th>
                  <th>Period 1</th>
                  <th>Period 2</th>
                  <th>Period 3</th>
                  <th>Break</th>
                  <th>Period 4</th>
                  <th>Period 5</th>
                  <th>Period 6</th>
                </tr>
              </thead>
              <tbody>
                {days.map((day) => (
                  <tr key={day}>
                    <td className="fw-bold">{day}</td>
                    {timetable[day]?.map((period, idx) => (
                      <td key={idx}>
                        <div className="small">
                          <strong>{period.subject}</strong><br />
                          {period.teacher}<br />
                          <span className="text-muted">{period.time}</span>
                        </div>
                      </td>
                    )) || <td colSpan={7} className="text-center text-muted">No schedule</td>}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimeTable;